import { render, staticRenderFns } from "./wisdom_subject_detail.vue?vue&type=template&id=5eaf75fa&"
import script from "./wisdom_subject_detail.vue?vue&type=script&lang=js&"
export * from "./wisdom_subject_detail.vue?vue&type=script&lang=js&"
import style0 from "./wisdom_subject_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports